import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import * as styles from './Service.css';
import { formatAmount, formatPoints } from '../../../../../../../../utils/string';
import { IBuyPackageService } from '../../../../../../../../types';

interface IProps {
  service: IBuyPackageService;
}

export const Service = (props: IProps) => {
  const { name, count, auctionPoints } = props.service;

  return (
    <>
      <div className={styles['row']}>
        <UIText1>{name}</UIText1>

        <UIText1 fontWeight="bold">{formatAmount(count)}</UIText1>
      </div>

      {!!auctionPoints && (
        <div className={styles['row']}>
          <UIText1>Баллы</UIText1>

          <UIText1 textAlign="right" fontWeight="bold">
            {formatPoints(auctionPoints)}
          </UIText1>
        </div>
      )}
    </>
  );
};
